const houseTrailers = [
  {
    model: "TH444 PLATEAU - A",
    cargo_dimensions: "450 X 244 X 62 CM",
    total_length: "600 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "580 KG",
    loading_capacity: "2920 KG",
    price: 4050,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH450_2axles.jpg",
    imgAlt: "tiny house trailer",
  },
  {
    model: "TH540 PLATEAU - B",
    cargo_dimensions: "540 X 244 X 62 CM",
    total_length: "690 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "630 KG",
    loading_capacity: "2870 KG",
    price: 4200,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH540_2axles.jpg",
    imgAlt: "tiny house trailer",
  },
  {
    model: "TH540 PLATEAU - C",
    cargo_dimensions: "540 X 244 X 62 CM",
    total_length: "690 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "660 KG",
    loading_capacity: "2840 KG",
    price: 4450,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH540_3axles.jpg",
    imgAlt: "tiny house trailer",
  },
  {
    model: "TH540 PLATEAU - D",
    cargo_dimensions: "540 X 244 X 62 CM",
    total_length: "690 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "750 KG",
    loading_capacity: "2750 KG",
    price: 4800,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH540_3axles.jpg",
    imgAlt: "tiny house trailer",
  },
  {
    model: "TH600 PLATEAU - E",
    cargo_dimensions: "600 X 244 X 62 CM",
    total_length: "750 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "660 KG",
    loading_capacity: "2840 KG",
    price: 4300,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH600_2axles.jpg",
    imgAlt: "remorca pentru casuta mobila",
  },
  {
    model: "TH600 PLATEAU - F",
    cargo_dimensions: "600 X 244 X 62 CM",
    total_length: "750 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "690 KG",
    loading_capacity: "2810 KG",
    price: 4550,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH600_3axles.jpg",
    imgAlt: "remorca pentru casuta mobila",
  },
  {
    model: "TH600 PLATEAU - G",
    cargo_dimensions: "600 X 244 X 62 CM",
    total_length: "750 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "780 KG",
    loading_capacity: "2720 KG",
    price: 4900,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH600_3axles.jpg",
    imgAlt: "remorca pentru casuta mobila",
  },
  {
    model: "TH660 PLATEAU - H",
    cargo_dimensions: "660 X 244 X 62 CM",
    total_length: "810 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "690 KG",
    loading_capacity: "2810 KG",
    price: 4400,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH660_2axles.jpg",
    imgAlt: "remorca pentru tiny house",
  },
  {
    model: "TH660 PLATEAU - I",
    cargo_dimensions: "660 X 244 X 62 CM",
    total_length: "810 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "720 KG",
    loading_capacity: "2780 KG",
    price: 4650,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH660_3axles.jpg",
    imgAlt: "remorca pentru tiny house",
  },
  {
    model: "TH660 PLATEAU - J",
    cargo_dimensions: "660 X 244 X 62 CM",
    total_length: "810 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "810 KG",
    loading_capacity: "2690 KG",
    price: 5000,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH660_3axles.jpg",
    imgAlt: "remorca pentru tiny house",
  },
  {
    model: "TH720 PLATEAU - K",
    cargo_dimensions: "720 X 244 X 62 CM",
    total_length: "870 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "720 KG",
    loading_capacity: "2780 KG",
    price: 4500,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH720_2axles.jpg",
    imgAlt: "remorci tiny house",
  },
  {
    model: "TH720 PLATEAU - L",
    cargo_dimensions: "720 X 244 X 62 CM",
    total_length: "870 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "750 KG",
    loading_capacity: "2750 KG",
    price: 4850,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH720_3axles.jpg",
    imgAlt: "trailer for tiny house",
  },
  {
    model: "TH720 PLATEAU - M",
    cargo_dimensions: "720 X 244 X 62 CM",
    total_length: "870 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "840 KG",
    loading_capacity: "2660 KG",
    price: 5150,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH720_3axles.jpg",
    imgAlt: "platforma casuta mobila",
  },
  {
    model: "TH780 PLATEAU - N",
    cargo_dimensions: "780 X 244 X 62 CM",
    total_length: "930 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "760 KG",
    loading_capacity: "2740 KG",
    price: 4600,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH780_2axles.jpg",
    imgAlt: "remorci causta mobila",
  },
  {
    model: "TH780 PLATEAU - O",
    cargo_dimensions: "780 X 244 X 62 CM",
    total_length: "930 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "790 KG",
    loading_capacity: "2710 KG",
    price: 4950,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH780_3axles.jpg",
    imgAlt: "trailer pentru casuta mobila",
  },
  {
    model: "TH780 PLATEAU - P",
    cargo_dimensions: "780 X 244 X 62 CM",
    total_length: "930 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "880 KG",
    loading_capacity: "2620 KG",
    price: 5250,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH780_3axles.jpg",
    imgAlt: "casa pe roti",
  },
  {
    model: "TH840 PLATEAU - Q",
    cargo_dimensions: "840 X 244 X 62 CM",
    total_length: "990 CM",
    axles: "2 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "810 KG",
    loading_capacity: "2690 KG",
    price: 4750,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH840_2axles.jpg",
    imgAlt: "remorca casa",
  },
  {
    model: "TH840 PLATEAU - R",
    cargo_dimensions: "840 X 244 X 62 CM",
    total_length: "990 CM",
    axles: "3 X AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "840 KG",
    loading_capacity: "2660 KG",
    price: 5150,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH840_3axles.jpg",
    imgAlt: "trailer pentru tiny house",
  },
  {
    model: "TH840 PLATEAU - S",
    cargo_dimensions: "840 X 244 X 62 CM",
    total_length: "990 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "940 KG",
    loading_capacity: "2560 KG",
    price: 5450,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH840_3axles.jpg",
    imgAlt: "trailer pentru tiny house",
  },
  {
    model: "TH1000 PLATEAU - T",
    cargo_dimensions: "1000 X 244 X 62 CM",
    total_length: "1150 CM",
    axles: "3 X AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "1080 KG",
    loading_capacity: "2420 KG",
    price: 5950,
    newPrice: null,
    img: "images/tiny-house-trailers-2026/TH1000_3axles.jpg",
    imgAlt: "tiny house trailer",
  },
];

export default houseTrailers;
